import React from 'react';
import PlaceIcon from '@mui/icons-material/Place';
import PhoneIcon from '@mui/icons-material/Phone';
import QRCode from "../QRCode/qrcode.jpg";
import EmailIcon from '@mui/icons-material/Email';
const ReturnBillPrint = ({ onClose, labelData }) => {
    const containerStyle = {
        border: '1px solid #000',
        padding: '5px',
        width: '700px',
        height: '900px',
    };

    const printStyles = `
        @media print {
            body {
                margin: 10px;
            }
        }
    `;

    if (!labelData || labelData.length === 0) {
        return null;
    }

    const firstItem = labelData[0];

    const NumberToWords = (num) => {
        const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
        const teens = ['Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
        const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

        const convert = (num) => {
            if (num < 10) return units[num];
            if (num < 20) return teens[num - 11];
            if (num < 100) return tens[Math.floor(num / 10)] + ' ' + units[num % 10];
            if (num < 1000) return units[Math.floor(num / 100)] + ' Hundred ' + convert(num % 100);
            if (num < 10000) return units[Math.floor(num / 1000)] + ' Thousand ' + convert(num % 1000);
            return 'Number is too large';
        };

        if (num === 0) return 'Zero';
        return convert(num);
    };

    const AmountInWords = ({ amount }) => {
        const formattedAmount = parseFloat(amount).toFixed(2);
        const [rupees, decimal] = formattedAmount.split('.');

        return (
            <div>
                <h5>Rupees {NumberToWords(parseInt(rupees))} Only</h5>
                {decimal !== "00" && <p>{NumberToWords(parseInt(decimal))} Paise Only</p>}
            </div>
        );
    };

    return (
        <div style={{ ...containerStyle, padding: '20px' }}>
            <style>{printStyles}</style>
            {firstItem && firstItem.saleReturnPrint && (
                <div>
                    <h2 style={{ textAlign: 'center', marginBottom: '10px', color: 'blue', fontWeight: 'bold',marginTop:'-15px' }}>
                        {firstItem.saleReturnPrint.companyName}
                    </h2>

                    <div style={{ marginBottom: '5px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                            <PlaceIcon style={{ color: 'green', width: '30px', height: '30px' }} />
                            <span style={{ marginLeft: '5px', color: 'black', fontWeight: 'bolder', fontSize: '14px' }}>
                                {firstItem.saleReturnPrint.address}, {firstItem.saleReturnPrint.address1}
                            </span>
                        </div>
                        <div style={{ marginLeft: '35px', marginBottom: '5px' }}>
                            <span style={{ color: 'black', fontWeight: 'bolder', fontSize: '14px' }}>
                                {firstItem.saleReturnPrint.location} - {firstItem.saleReturnPrint.pincode}
                            </span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                            <PhoneIcon style={{ color: 'blue', width: '30px', height: '30px' }} />
                            <span style={{ marginLeft: '5px', color: 'black', fontWeight: 'bolder', fontSize: '14px' }}>
                                {firstItem.saleReturnPrint.companyContactNumber}  {firstItem.saleReturnPrint.email}
                            </span>
                        </div>
                        <div style={{ marginLeft: '5px', marginTop: '10px' }}>
                            <h3 style={{ fontWeight: 'bolder', fontSize: '14px' }}>
                                GST NO: {firstItem.saleReturnPrint.gstNumber}
                            </h3>
                        </div>
                    </div>
                    <hr style={{ border: 'none', borderTop: '1px solid black', margin: '20px -20px', width: 'calc(100% + 40px)' }} />
                    <h2 style={{ textAlign: 'center', marginBottom: '7px',fontSize: '16px', fontWeight: 'bold' }}>
                        CREDIT NOTE
                    </h2>
                    <div style={{ marginBottom: '5px', fontSize: '16px' }}>
                        <strong style={{ fontSize: '14px' }}>Customer:{firstItem.saleReturnPrint.name}</strong>
                    </div>
                    <div style={{ marginBottom: '5px', fontSize: '16px' }}>
                        <strong style={{ fontSize: '14px' }}>Phone No:{firstItem.saleReturnPrint.contactNumber}</strong>
                    </div>
                    <div style={{ marginBottom: '5px', fontSize: '16px' }}>
                        <strong style={{fontSize: '14px' }}>Place:{firstItem.saleReturnPrint.customerAddess}</strong>
                    </div>

                    <div style={{ textAlign: 'right', marginBottom: '5px', fontSize: '16px' }}>
                        <strong style={{ fontSize: '14px'}}>CREDIT NOTE NO:{firstItem.saleReturnPrint.prefix}{firstItem.saleReturnPrint.returnNumber}/{firstItem.saleReturnPrint.finYear}</strong>
                    </div>

                    <div style={{ textAlign: 'right', marginBottom: '5px', fontSize: '16px' }}>
                        <strong style={{ fontSize: '14px' }}>RETURN DATE: {new Date(firstItem.saleReturnPrint.returnDate).toLocaleDateString('en-GB')}</strong>

                    </div>
                </div>
            )}

            {
                firstItem && firstItem.saleReturnPrintItem && (
                    <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
                        <thead>
                            <tr>
                                <th style={{ border: '1px solid #000', padding: '5px', fontWeight: '14px', width: '50px' }}>Sl No</th>
                                <th style={{ border: '1px solid #000', padding: '5px', fontWeight: '14px', width: '60px' }}>HSN</th>
                                <th style={{ border: '1px solid #000', padding: '5px', fontWeight: '14px', width: '200px' }}>Name</th>
                                <th style={{ border: '1px solid #000', padding: '5px', fontWeight: '14px', width: '70px' }}>Rate</th>
                                <th style={{ border: '1px solid #000', padding: '5px', fontWeight: '14px', width: '60px' }}>Qty</th>
                                <th style={{ border: '1px solid #000', padding: '5px', fontWeight: '14px', width: '100px' }}>Total Amt</th>
                            </tr>
                        </thead>
                        <tbody>
                            {firstItem.saleReturnPrintItem.map((item, index) => (
                                <tr key={index}>
                                    <td style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold', color: 'black' }}>{index + 1}</td>
                                    <td style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold', color: 'black' }}>{item.hsncode}</td>
                                    <td style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold', color: 'black' }}>{item.itemName}</td>
                                    <td style={{ border: '1px solid #000', padding: '5px', textAlign: 'right', fontWeight: 'bold', color: 'black' }}>{item.rate.toFixed(2)}</td>
                                    {/* <td style={{ border: '1px solid #000', padding: '5px', textAlign: 'right', fontWeight: 'bold', color: 'black' }}>{item.Discount}</td> */}
                                    <td style={{ border: '1px solid #000', padding: '5px', textAlign: 'center', fontWeight: 'bold', color: 'black' }}>{item.quantity}</td>
                                    <td style={{ border: '1px solid #000', padding: '5px', textAlign: 'right', fontWeight: 'bold', color: 'black' }}>{(item.totalAmount).toFixed(2)}</td>
                                </tr>
                            ))}
                        </tbody>

                        <tbody>
                            <tr>
                                {/* Bank Details */}
                                <td style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold', color: 'black' }} colSpan="4">
                                    <table style={{ width: '100%' }}>
                                        <thead>
                                            <tr>
                                                <th style={{ border: 'none', padding: '5px', fontWeight: 'bold', color: 'black', textAlign: 'left' }}>BANK   : AXIS BANK</th>
                                            </tr>

                                            <tr>
                                                <th style={{ border: 'none', padding: '5px', fontWeight: 'bold', color: 'black', textAlign: 'left' }}>BRANCH :ANGAMALY</th>
                                            </tr>
                                            <tr>
                                                <th style={{ border: 'none', padding: '5px', fontWeight: 'bold', color: 'black', textAlign: 'left' }}>A/C NAME : PETERS RICE MILL</th>
                                            </tr>
                                            <tr>
                                                <th style={{ border: 'none', padding: '5px', fontWeight: 'bold', color: 'black', textAlign: 'left' }}>A/C NO : 922030028095826</th>
                                            </tr>
                                            <tr>
                                                <th style={{ border: 'none', padding: '5px', fontWeight: 'bold', color: 'black', textAlign: 'left' }}>IFSC   : UTIB0001646</th>
                                            </tr>
                                            <tr>
                                                <th style={{ border: 'none', padding: '5px', fontWeight: 'bold', color: 'black', textAlign: 'left' }}></th>
                                            </tr>
                                        </thead>
                                    </table>
                                </td>

                                <td style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold', color: 'black' }} colSpan="1">
                                    <table style={{ width: '100%' }}>

                                        <tbody>
                                            <tr>
                                                <td style={{ padding: '5px', fontWeight: 'bold', color: 'black', textAlign: 'left' }}>NetValue</td>
                                            </tr>

                                            <tr>
                                                <td style={{ padding: '5px', fontWeight: 'bold', color: 'black', textAlign: 'left' }}>RoundOff</td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: '5px', fontWeight: 'bold', color: 'black', textAlign: 'left' }}>GrandTotal</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>

                                <td style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold', color: 'black' }} colSpan="1">
                                    <table style={{ width: '100%' }}>
                                        <tbody>
                                            <tr>
                                                <td style={{ padding: '5px', fontWeight: 'bold', color: 'black', textAlign: 'right' }}>
                                                    {(firstItem.saleReturnPrint.netAmount ?? 0).toFixed(2)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: '5px', fontWeight: 'bold', color: 'black', textAlign: 'right' }}>
                                                    {(firstItem.saleReturnPrint.roundOff ?? 0).toFixed(2)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: '5px', fontWeight: 'bold', color: 'black', textAlign: 'right' }}>
                                                    {(firstItem.saleReturnPrint.totalAmount ?? 0).toFixed(2)}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>


                            </tr>
                        </tbody>

                    </table>
                )
            }


            {firstItem && firstItem.saleReturnPrint && (
                <div>
                    <h5 style={{ marginTop: '-10px', marginLeft: '10px', marginBottom: '2px' }}><AmountInWords amount={firstItem.saleReturnPrint.totalAmount} /></h5>

                </div >
            )}


        </div >
    );
};

export default ReturnBillPrint;
